import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'

class BillingMethodCostLabel extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            billingMethod: this.props.billingMethod || '',
            pricingStrategy: this.props.pricingStrategy || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            billingMethod: nextProps.billingMethod || '',
            pricingStrategy: nextProps.pricingStrategy || '',
        })
    }

    componentDidMount() {}

    renderOneTime() {
        switch (this.state.pricingStrategy) {
            case "multiplier":
            case "custom-formula":
                return <FormattedMessage
                    id="common.billing_method.one_time.label.multiplier.cost_label"
                    defaultMessage="Unit cost"
                />
            case "bracket":
                return <FormattedMessage
                    id="common.billing_method.one_time.label.bracket.cost_label"
                    defaultMessage="Box unit cost"
                />
            case "bracket-custom":
                return <FormattedMessage
                    id="common.billing_method.one_time.label.custom_bracket.cost_label"
                    defaultMessage="Bracket cost"
                />
            case "bulk":
                return <FormattedMessage
                    id="common.billing_method.one_time.label.bulk.cost_label"
                    defaultMessage="Unit cost"
                />
        }
        return ''
    }

    renderMonthly() {
        switch (this.state.pricingStrategy) {
            case "multiplier":
            case "custom-formula":
                return <FormattedMessage
                    id="common.billing_method.monthly.label.multiplier.cost_label"
                    defaultMessage="Monthly unit cost"
                />
            case "bracket":
                return <FormattedMessage
                    id="common.billing_method.monthly.label.bracket.cost_label"
                    defaultMessage="Monthly box unit cost"
                />
            case "bracket-custom":
                return <FormattedMessage
                    id="common.billing_method.monthly.label.custom_bracket.cost_label"
                    defaultMessage="Monthly bracket cost"
                />
            case "bulk":
                return <FormattedMessage
                    id="common.billing_method.monthly.label.bulk.cost_label"
                    defaultMessage="Monthly unit cost"
                />
        }
        return ''
    }

    renderYearly() {
        switch (this.state.pricingStrategy) {
            case "multiplier":
            case "custom-formula":
                return <FormattedMessage
                    id="common.billing_method.yearly.label.multiplier.cost_label"
                    defaultMessage="Yearly unit cost"
                />
            case "bracket":
                return <FormattedMessage
                    id="common.billing_method.yearly.label.bracket.cost_label"
                    defaultMessage="Yearly box unit cost"
                />
            case "bracket-custom":
                return <FormattedMessage
                    id="common.billing_method.yearly.label.custom_bracket.cost_label"
                    defaultMessage="Yearly bracket cost"
                />
            case "bulk":
                return <FormattedMessage
                    id="common.billing_method.yearly.label.bulk.cost_label"
                    defaultMessage="Yearly unit cost"
                />
        }
        return ''
    }


    render() {
        switch (this.state.billingMethod) {
            case "one-time":
                return this.renderOneTime()
            case "monthly":
                return this.renderMonthly()
            case "yearly":
                return this.renderYearly()
        }
        return ''
    }
}

export default BillingMethodCostLabel





// WEBPACK FOOTER //
// ./src/product/billing-method/costlabel.component.jsx